import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

interface ISizeSelector {
  value: string
  onChange: (newValue: string) => void
}

export const BorderTypeSelector = ({ value, onChange }: ISizeSelector) => {
  const source = useMemo(() => {
    const data = ['dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'none']
    const crud = new BaseCrud({
      fetcher: new Static(
        data.map((el) => {
          return { id: el, label: el }
        })
      ),
      keyField: 'id',
    })
    crud.setPaging({
      page: 0,
      pageSize: 100,
    })
    return crud
  }, [])

  return (
    <Dropdown
      source={source}
      caption={'label'}
      onChange={onChange}
      value={value}
      label={`Select border type`}
    />
  )
}
